const MONTHLY_RATE_LARGE = 125

export {
  MONTHLY_RATE_LARGE
}
